/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Suggquiz1Inputs */

const zh_landing_copilot_suggquiz1 = /** @type {(inputs: Landing_Copilot_Suggquiz1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测验生成`)
};

const en_landing_copilot_suggquiz1 = /** @type {(inputs: Landing_Copilot_Suggquiz1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiz Generating`)
};

const es_landing_copilot_suggquiz1 = /** @type {(inputs: Landing_Copilot_Suggquiz1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar cuestionarios`)
};

/**
* | output |
* | --- |
* | "Quiz Generating" |
*
* @param {Landing_Copilot_Suggquiz1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_copilot_suggquiz1 = /** @type {((inputs?: Landing_Copilot_Suggquiz1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Suggquiz1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_suggquiz1(inputs)
	if (locale === "en") return en_landing_copilot_suggquiz1(inputs)
	return es_landing_copilot_suggquiz1(inputs)
});
export { landing_copilot_suggquiz1 as "landing_copilot_suggQuiz" }